import loadLiveEngage from './liveEngage';
import enableGliaScript from './glia';

const loadThirdPartyScript = ({ enableGlia, isWeb, liveEngageKey, user }) => {
  if (isWeb) loadLiveEngage(liveEngageKey, user);
  if (isWeb) enableGliaScript(enableGlia);
};

export default loadThirdPartyScript;
